module.exports = __webpack_public_path__ + "static/media/servers.b32b0b85.png";